import classNames from 'classnames';
import React, { useContext } from 'react';
import { useUserContext } from '@fff-web/fff-utilities';
import spacetime from 'spacetime';
import GlobalNavContext from '../../context/globalNavContext';
import { useBootstrapLD } from '../../hooks/useBootstrapLD';
import {
  NEW_MEMBER_CUSTOMIZE,
  NEW_MEMBER_OPEN,
  useNewMemberCampaignState,
} from '../../hooks/useNewMemberCampaignState';
import { useNmfRedirect } from '../../hooks/useNmfRedirect';
import { useNmfTimer } from '../../hooks/useNmfTimer';
import NmfTimeUp from '../Modals/NmfTimeUp';
import NewMemberNav from '../NMF/NewMemberNav';
import TimerBar from '../TimerBar/TimerBar';
import './Header.css';
import NMFHeaderContent from './NMFHeaderContent';
import { buildUserInfoRequest } from '../../helpers/userAdapter';
import NavToast from '../Toast';

const TIMER_SOURCE = {
  introProduct: 'introProduct',
  publicCustomize: 'publicCustomize',
};

const NMFHeader = ({ env, step, showDetailed = false, setRedirectLoading }) => {
  const userRequest = buildUserInfoRequest(useUserContext().userInfo);
  const {
    endTime,
    userId,
    newMemberState,
    lastVisitedCustomizeQuestionId,
    timerType,
    timerSource,
  } = useNmfTimer();
  const { flag: nmfTimerFlag, flagReady: nmfTimerFlagReady } = useBootstrapLD(
    env,
    'nmf-timer',
    userId,
  );
  const { flag: hideCustomizeNodeFlag, flagReady: hideCustomizeNodeFlagReady } =
    useBootstrapLD(env, 'new-nmf-does-not-show-customize-node', userId);
  const { flag: hideIntroNodeFlag, flagReady: hideIntroNodeFlagReady } =
    useBootstrapLD(env, 'New-NMF-Does-Not-Show-Intro-Node', userId);
  const {
    flag: dontRedirectToFlashSaleFlag,
    flagReady: dontRedirectToFlashSaleFlagReady,
  } = useBootstrapLD(
    env,
    'new-member-flow-dont-redirect-to-flash-sale',
    userId,
  );
  const { customizePage, customizePhase } = useNewMemberCampaignState(
    env,
    nmfTimerFlag,
  );
  const { env: globalEnv } = useContext(GlobalNavContext);
  const baseUrl = globalEnv.REACT_APP_BASE_URL;
  useNmfRedirect(
    newMemberState,
    lastVisitedCustomizeQuestionId,
    baseUrl,
    timerType,
    setRedirectLoading,
  );

  // Using nmfTimerFlagReady to wait for response from LD
  // so the timer doesn't flash and disappear if the user shouldn't see it.
  const showTimer =
    nmfTimerFlagReady &&
    (!nmfTimerFlag ||
      (nmfTimerFlag &&
        customizePage === NEW_MEMBER_OPEN &&
        customizePhase === NEW_MEMBER_CUSTOMIZE));

  const skipCustomize =
    timerSource === TIMER_SOURCE.introProduct ||
    timerSource === TIMER_SOURCE.publicCustomize;

  // Hide the customize node for FC on GTB
  const hideCustomizeNode =
    (hideCustomizeNodeFlagReady && hideCustomizeNodeFlag) || skipCustomize;
  const hideIntroNode =
    (hideIntroNodeFlagReady && hideIntroNodeFlag) || skipCustomize;
  const expTime = spacetime(`${endTime}Z`);

  return (
    <>
      <div
        className={classNames('header', {
          header__nmf: true,
        })}
      >
        <div className="header__wrapper">
          <NMFHeaderContent />
        </div>
      </div>
      {showDetailed && (
        <>
          {!!endTime && (
            <NmfTimeUp
              expDate={new Date(expTime.format('iso-utc'))}
              userRequest={userRequest}
              dontRedirectToFlashSaleFlag={
                dontRedirectToFlashSaleFlag && dontRedirectToFlashSaleFlagReady
              }
            />
          )}
          {!!endTime && showTimer && (
            <TimerBar endTime={new Date(expTime.format('iso-utc'))} />
          )}
          {hideCustomizeNodeFlagReady && hideIntroNodeFlagReady && (
            <NewMemberNav
              step={step}
              hideCustomizeNode={hideCustomizeNode}
              hideIntroNode={hideIntroNode || timerType === 'REACTIVATION'}
              hideSurveyNode={timerType === 'REACTIVATION'}
            />
          )}
        </>
      )}
      <NavToast />
    </>
  );
};

export default NMFHeader;
